export class GenderError extends Error {
    constructor(msg?: string) {
        super(msg);
        this.name = 'GenderError';
    }
}
